import axios from "axios";
import { request } from "../api";

export const getMeta = () => request.get("/belege/meta");
export const getStats = () => request.get("/belege/stats");
export const listBelege = body => request.post("/belege/list", body);
export const getBeleg = id => request.get(`/belege/${id}`);
export const updateBeleg = (id, body) => request.put(`/belege/${id}`, body);
export const approveBeleg = (id, body) => request.post(`/belege/${id}/approve`, body);
export const bookBeleg = (id, body) => request.post(`/belege/${id}/book`, body);
export const rejectBeleg = (id, body) => request.post(`/belege/${id}/reject`, body);
export const reextractBeleg = (id, language) =>
  request.post(`/belege/${id}/reextract`, { language });
export const fetchBelegFile = id => request.blob(`/belege/${id}/file`);

// Supplier credit notes (link to the corrected invoice, offset a credit balance)
export const getCreditOptions = id => request.get(`/belege/${id}/credit-options`);
export const linkCreditNote = (id, invoice) => request.post(`/belege/${id}/link`, { invoice });
export const offsetCredit = (id, body) => request.post(`/belege/${id}/offset`, body);

// Gutschriftverfahren (self-billing)
export const createSelfBilling = body => request.post("/belege/self-billing", body);
export const updateSelfBilling = (id, body) => request.put(`/belege/self-billing/${id}`, body);
export const issueSelfBilling = id => request.post(`/belege/self-billing/${id}/issue`);
export const objectSelfBilling = (id, body) =>
  request.post(`/belege/self-billing/${id}/objection`, body);
export const fetchSelfBillingPdf = id => request.blob(`/belege/self-billing/${id}/pdf`);

export const uploadBelege = (files, { source = "upload", language = "de" } = {}) => {
  const body = new FormData();
  files.forEach(file => body.append("files", file, file.name));
  body.append("source", source);
  body.append("language", language);
  return request.upload("/belege/upload", body);
};

export const lookupSupplier = params => request.get("/suppliers/lookup", params);
export const listSuppliers = params => request.get("/suppliers", params);
export const createSupplier = body => request.post("/suppliers", body);

/** Projects double as cost centres; the list endpoint lives outside /accounting. */
export const listProjects = (serviceProvider, searchText = "") =>
  axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/projects/limited`,
    { serviceProvider, searchText, pageSize: 100, pageNo: 0 },
    { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
  );
